import { useContext } from 'react';
import { AuthContext } from '../contexts';
const useAuthenticated = () => {
    const { authenticated } = useContext(AuthContext);
    return authenticated;
};
export default useAuthenticated;
//# sourceMappingURL=isAuthenticated.js.map